import './Footer.css'

const Footer = () => {
    return (
        <footer>
            <div className='container'>
                <div className='footer'>
                    <p>Copyright © 2036 <a className='link' href='/#'>Cyborg Gaming</a> Company. All rights reserved.
                        Design: <a className='link' href='/#'>TemplateMo</a></p>
                </div>
            </div>
        </footer >
    )
}

export default Footer